import { apiRequest } from '@/utils/request'

// 查询容量列表
export function getIndex(data) {
    return apiRequest({
        url: '/system/capacity/list',
        method: 'get',
        params: data
    })
}

// 查询联系信息列表
export function listContactInfo(query) {
    return apiRequest({
        url: '/system/contactInfo/list',
        method: 'get',
        params: query
    })
}


// 查询视频管理列表
export function listVideoManager(query) {
    return apiRequest({
        url: '/system/videoManager/list',
        method: 'get',
        params: query
    })
}

// 查询首页四张图板块图片列表
export function listModelManager(query) {
    return apiRequest({
        url: '/system/modelManager/list',
        method: 'get',
        params: query
    })
}

// 查询公司信息列表
export function listCompanyInfo(query) {
    return apiRequest({
        url: '/system/companyInfo/list',
        method: 'get',
        params: query
    })
}


// 查询招聘信息列表
export function listHire(query) {
    return apiRequest({
        url: '/system/hire/list',
        method: 'get',
        params: query
    })
}


// 查询新闻列表
export function listNews(query) {
    return apiRequest({
        url: '/system/news/list',
        method: 'get',
        params: query
    })
}

// 查询新闻详细
export function getNews(id) {
    return apiRequest({
        url: '/system/news/' + id,
        method: 'get'
    })
}


// 查询首页四张图板块图片详细
export function getModelManager(id) {
    return apiRequest({
        url: '/system/modelManager/' + id,
        method: 'get'
    })
}


// 查询产品列表
export function listProduct(query) {
    return apiRequest({
        url: '/system/product/list',
        method: 'get',
        params: query
    })
}

// 查询产品详细
export function getProduct(id) {
    return apiRequest({
        url: '/system/product/' + id,
        method: 'get'
    })
}

// 查询产品详细
export function getNextInfo(query) {
    return apiRequest({
        url: '/system/product/getNextInfo',
        method: 'get',
        params: query
    })
}

// 查询容量列表
export function listCapacity(query) {
    return apiRequest({
        url: '/system/capacity/getList',
        method: 'get',
        params: query
    })
}


// 查询芯片制造商列表
export function listChipManufacturer(query) {
    return apiRequest({
        url: '/system/chipManufacturer/getList',
        method: 'get',
        params: query
    })
}

// 查询芯片组织列表
export function listChipOragnrzation(query) {
    return apiRequest({
        url: '/system/chipOragnrzation/getList',
        method: 'get',
        params: query
    })
}

// 查询特色列表
export function listFeature(query) {
    return apiRequest({
        url: '/system/feature/getList',
        method: 'get',
        params: query
    })
}

// 查询制造商列表
export function listManufacturer(query) {
    return apiRequest({
        url: '/system/manufacturer/getList',
        method: 'get',
        params: query
    })
}


// 查询工作温度列表
export function listOperatingTemperature(query) {
    return apiRequest({
        url: '/system/operatingTemperature/getList',
        method: 'get',
        params: query
    })
}
// 发送验证码
export function sendEmailCode(query) {
    return apiRequest({
        url: '/system/emailCode/send',
        method: 'get',
        params: query
    })
}

// 验证验证码
export function verify(query) {
    return apiRequest({
        url: '/system/emailCode/verify',
        method: 'get',
        params: query
    })
}
